import React, { ReactNode, useMemo } from "react";

import { debugSearchResultsName } from "./debug.search.results";
import { useDebug } from "@me8eon/debug";
import { DataHasType } from "@me8eon/data";
import { normaliseWidgetDefns, useDataViews } from "@me8eon/data_views";
import { useSelectedDataViewName } from "@me8eon/data_view_filter";
import { useThrowError } from "@me8eon/throw_error";
import { useDataWidgets } from "@me8eon/data_widget";
import { nameWithOptions } from "@me8eon/string_utils";
import "./display.search.results.scss";
import { useDevModeSelected } from "@me8eon/devmode";
import { Explain } from "@me8eon/diagnostics";

export type DisplaySearchResults = <Data extends DataHasType> (props: DisplaySearchResultsProps<Data>) => ReactNode

//At the moment we are just repeating the existing
//code in the main application
//So the data all came from one application, and there's just the list of it
export type DisplaySearchResultsProps<Data> = {
    rootId: string
    data: Data[]
}

export const DisplaySearchResults: DisplaySearchResults =
    <Data extends DataHasType>({ rootId, data }: DisplaySearchResultsProps<Data>): ReactNode => {
        const debug = useDebug(debugSearchResultsName);
        const dataWidgets = useDataWidgets();
        const [selected] = useSelectedDataViewName();
        const dataViews = useDataViews();
        const throwError = useThrowError();
        const dataView = dataViews[selected];
        if (!dataView)
            throwError(`s/w`, `No data view selected: ${selected}. Legal values are ${Object.keys(dataViews).sort()}`);
        const widgets = useMemo(() => normaliseWidgetDefns(dataView.widgets), [dataView.widgets]);
        const Layout = dataView.SearchResultLayout;
        return <Layout rootId={rootId}>{
            widgets.map(({ widget: w, width }) => {
                const { name, options } = nameWithOptions(w);
                const widget = dataWidgets[name];
                if (!widget) return throwError(`s/w`, `No widget with name ${w}. Legal values are ${Object.keys(dataWidgets).sort()} `);
                const Display = widget.display;

                return <div className={`widget-width-${width}`} key={w} data-widget={w}><Display rootId={rootId} data={data} widgetName={w} options={options} /></div>;
            })
        }</Layout>;
    };
